import { Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { Icon } from "../lib/Icon";
import { ErrorNote, Loading, Page } from "./common";

const SEV_TONE: Record<string, { bg: string; fg: string }> = {
  Major: { bg: "#fbe9e7", fg: "#b3261e" },
  Minor: { bg: "#fbf2dc", fg: "#9a6a12" },
};
const STATUS_TONE: Record<string, { bg: string; fg: string }> = {
  Investigating: { bg: "#fbf2dc", fg: "#9a6a12" },
  Identified: { bg: "#e8f0f3", fg: "#2a6f8a" },
  Monitoring: { bg: "#e8f0f3", fg: "#2a6f8a" },
  Resolved: { bg: "#e8f4ee", fg: "#1f8a5b" },
};

export function Incidents() {
  const { data, isLoading, error } = useQuery({ queryKey: ["incidents"], queryFn: api.incidents });
  if (isLoading) return <Loading />;
  if (error || !data) return <ErrorNote error={error} />;

  return (
    <Page>
      <div>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 600, letterSpacing: "-0.6px" }}>Incidents & status</h1>
        <div style={{ fontSize: 14, color: "#8a8e88", marginTop: 3 }}>An update posts to the client’s status page, widget banner and linked requesters</div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        {data.map((inc) => {
          const sev = SEV_TONE[inc.severity] ?? SEV_TONE.Minor!;
          const st = STATUS_TONE[inc.status] ?? { bg: "#f0efe9", fg: "#6b706a" };
          return (
            <div key={inc.id} style={{ background: "#fff", borderRadius: 3, boxShadow: "inset 0 0 0 1px rgba(0,0,0,.07)", padding: "16px 18px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 9 }}>
                <span style={{ fontFamily: "'Space Mono',monospace", fontSize: 12, color: "#8a8e88" }}>{inc.id}</span>
                <span style={{ fontSize: 15, fontWeight: 600, flex: 1 }}>{inc.title}</span>
                {inc.clientId ? (
                  <Link to="/status/$clientId" params={{ clientId: inc.clientId }} style={{ fontSize: 11, fontWeight: 600, color: "#16243a", background: "#e8ebf0", borderRadius: 4, padding: "3px 8px", textDecoration: "none" }} title="Open public status page">{inc.clientName}</Link>
                ) : (
                  <span style={{ fontSize: 11, fontWeight: 600, color: "#16243a", background: "#e8ebf0", borderRadius: 4, padding: "3px 8px" }}>{inc.clientName}</span>
                )}
                <span style={{ fontSize: 10.5, fontWeight: 600, padding: "3px 9px", borderRadius: 999, background: sev.bg, color: sev.fg }}>{inc.severity}</span>
                <span style={{ fontSize: 10.5, fontWeight: 600, padding: "3px 9px", borderRadius: 999, background: st.bg, color: st.fg }}>{inc.status}</span>
              </div>
              <div style={{ marginTop: 12, display: "flex", flexDirection: "column" }}>
                {inc.updates.map((u, i) => (
                  <div key={i} style={{ display: "flex", gap: 10, padding: "9px 0", borderTop: "1px solid #f4f3ee" }}>
                    <Icon name="megaphone" size={14} color="#006747" style={{ marginTop: 2 }} />
                    <div style={{ flex: 1 }}>
                      {u.status && <span style={{ fontSize: 11, fontWeight: 600, color: "#4a504a" }}>{u.status} · </span>}
                      <span style={{ fontSize: 12.5, color: "#4a504a" }}>{u.body}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </Page>
  );
}
